import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
export class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits
   * Cart buttons are always managed client-side, never server-disabled
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    // Cart buttons are always dynamically managed.
    // Casa del Bacalao: el "−" nunca se apaga; en la cantidad mínima quita la línea del carrito
    // (un cliente reportó que "no se puede borrar": tocaba el − en 1 y no pasaba nada).
    minusButton.disabled = false;
    minusButton.classList.toggle('quantity-minus--quita', value <= min);
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
  }

  /**
   * En la cantidad mínima, el "−" equivale al botón de quitar de la misma línea.
   * @param {Event} event
   */
  decreaseQuantity(event) {
    const { min, value } = this.getCurrentValues();
    if (value <= min) {
      event.preventDefault();
      const fila = this.closest('.cart-items__table-row');
      const quitar = fila?.querySelector('.cart-items__remove');
      if (quitar instanceof HTMLElement && !quitar.hasAttribute('disabled')) {
        quitar.click();
        return;
      }
    }
    super.decreaseQuantity(event);
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
